import { render } from "./ViewWrapper.vue?vue&type=template&id=4e4b7644"
import script from "./ViewWrapper.vue?vue&type=script&lang=js"
export * from "./ViewWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/CSS/ViewWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e4b7644"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e4b7644', __exports__)) {
    api.reload('4e4b7644', __exports__)
  }
  
  module.hot.accept("./ViewWrapper.vue?vue&type=template&id=4e4b7644", () => {
    api.rerender('4e4b7644', render)
  })

}


export default __exports__